import React, { useState, useEffect } from "react";
import { Box, TextField, Button, MenuItem, Select } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import styles from "../../../../styles/gri/general.module.css";
import { put, get } from "../../../../utils/api";
import EastIcon from "@mui/icons-material/East";
import GRISidebar from "../../../../Layout/GRISidebar";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

export default function GRI302_5({ hide }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [formData, setFormData] = useState({
    energyReductionsAchieved: {
      amount: "",
      unit: "",
    },
    energyReductionBasis: "",
    energyReductionMethodologies: "",
  });
  const [griReview, setGriReview] = React.useState(() => JSON.parse(localStorage.getItem("griReview")));

  React.useEffect(() => {
    const handleStorage = () => setGriReview(JSON.parse(localStorage.getItem("griReview")));
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);
  React.useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const handleSubmit = async () => {
    if (!disabled) {
      try {
        const res = await put(`/gri/update?Id=${id}`, {
          type: "GRI300",
          submitted302_5: true,
          reductionEnergyRequirement: { ...formData },
        })
          .then((res) => navigate(`/gri/gri300/303-1/${id}`))
          .catch((err) => console.log(err));
      } catch (error) {
        console.log(error);
        // setsnackOpen({
        //   open: true,
        //   message: error.data.message,
        //   severity: "error",
        // });
      }
    } else {
      navigate(`/gri/gri300/303-1/${id}`);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const [main, sub] = name.split(".");
    setFormData((prev) => {
      if (sub) {
        return {
          ...prev,
          [main]: {
            ...prev[main],
            [sub]: value,
          },
        };
      } else {
        return { ...prev, [main]: value };
      }
    });
  };

  const handleChangeNumber = (e) => {
    const { name, value } = e.target;
    if (!/^\d*$/.test(value)) return;
    const [main, sub] = name.split(".");
    setFormData((prev) => {
      if (sub) {
        return {
          ...prev,
          [main]: {
            ...prev[main],
            [sub]: value,
          },
        };
      } else {
        return { ...prev, [main]: value };
      }
    });
  };

  const fetchData = async () => {
    await get(`/gri/get?Id=${id}&type=GRI300`).then((res) => {
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      const response = res?.data?.data?.GRI300?.reductionEnergyRequirement;
      setFormData({
        energyReductionsAchieved: {
          amount: response?.energyReductionsAchieved?.amount,
          unit: response?.energyReductionsAchieved?.unit,
        },
        energyReductionBasis: response?.energyReductionBasis,
        energyReductionMethodologies: response?.energyReductionMethodologies,
      });
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const renderContent = ({ hide }) => (
    <>
      {!hide && <p className={styles.section_heading} style={{ textDecoration: "none" }}>
        302 : <span className={styles.main_heading_underline}>ENERGY</span>
      </p> }
      <p className={styles.main_heading} style={{marginBottom : hide ? "-1rem" : "0", }}>
        302-5 :{" "}
        <span className={styles.main_heading_underline}>
          Reductions in energy requirements of products and services
        </span>
      </p>
      <Box>
        <p className={styles.ques_heading}>
          a. Total fuel consumption within the organization from non-renewable
          sources
        </p>
        <Box
          sx={{
            display: "flex",
            gap: 1,
            mt: 3,
            mb: 2,
            ml: 2,
          }}
        >
          <p>Amount:</p>
          <TextField
            size="small"
            placeholder="Enter Number"
            name={`energyReductionsAchieved.amount`}
            value={formData?.energyReductionsAchieved?.amount}
            onChange={handleChangeNumber}
            //   error={errors.totalRecycled}
            disabled={disabled}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: 4,
            mt: 3,
            mb: 2,
            ml: 2,
          }}
        >
          <p>Unit:</p>
          <Select
            sx={{
              height: "2rem",
              width: "24%",
            }}
            name={`energyReductionsAchieved.unit`}
            value={formData?.energyReductionsAchieved?.unit || ""}
            placeholder="Select"
            onChange={handleChange}
            displayEmpty
            size="small"
            disabled={disabled}
            //  fullWidth
            // disabled={!data?.[DropDownData?.fieldName]?.[list?.fields]?.active}
          >
            <MenuItem value="">
              <em>Select</em>
            </MenuItem>
            {["MJ", "GJ", "TJ"].map((data, index) => (
              <MenuItem key={index} value={data}>
                {data}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </Box>
      <Box>
        <p className={styles.ques_heading} style={{ display: "flex", marginTop : hide ? "-1rem" : "0", }}>
          b. Basis for calculating reductions in energy consumption, such as
          base year or baseline, including the rationale for choosing it
        </p>
        <TextField
          size="small"
          placeholder="Enter Text"
          fullWidth
          sx={{ ml: 2, mr: 2, width: "98%" }}
          name={`energyReductionBasis`}
          value={formData?.energyReductionBasis}
          onChange={handleChange}
          disabled={disabled}
          //   error={errors.totalRecycled}
        />
      </Box>
      <Box>
        <p className={styles.ques_heading} style={{marginTop : hide ? "-0.5rem" : "0",}}>
          c. Standards, methodologies, assumptions, and/or calculation tools
          used.
        </p>
        <TextField
          size="small"
          placeholder="Enter Text"
          fullWidth
          sx={{ ml: 2, mr: 2, width: "98%" }}
          name={`energyReductionMethodologies`}
          value={formData?.energyReductionMethodologies}
          onChange={handleChange}
          disabled={disabled}
          //   error={errors.totalRecycled}
        />
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
}
